/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { observer } from "mobx-react-lite"
import { useNavigate, useParams } from "react-router"

import type { ApplicationDetail } from "../../features/application-detail/application-detail-types"
import { ApplicationSearchViewmodel } from "../../features/application-search/application-search-viewmodel"
import { useViewModel } from "../app/app-hooks"
import { ApplicationListItem } from "../application/application-list-item"
import { ApplicationSearch } from "../ui-widgets/application-search/application-search"

import "./application-search-view.css"

export const ApplicationResultView = observer(() => {
    const { query } = useParams<{ query: string }>()
    const vm = useViewModel(ApplicationSearchViewmodel)
    const searchVM = useViewModel(ApplicationSearchViewmodel)
    const navigate = useNavigate()

    return (
        <div className="w-content application-search-view">
            <div className="col-xxl-10">
                <div className="flex flex-wrap gap-y-2 justify-between items-center mb-6">
                    <h3 className="title mb-0">Application search</h3>
                    <ApplicationSearch
                        onSearch={async (query: string) => {
                            const redirect = await searchVM.searchApplicationByQuery(query)
                            if (redirect) {
                                navigate(redirect)
                            }
                        }}
                    />
                </div>

                {vm.searchResults(query ?? "").length === 0 && (
                    <div className="no-results">
                        No results found for: <span className="query">{query}</span>
                    </div>
                )}

                <div className="mt-12 mb-12">
                    <div className="page-container my-6">
                        <div className="row row-cols-1 row-cols-md-2 g-4">
                            {vm.searchResults(query ?? "").map(renderDetail)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

function renderDetail(detail: ApplicationDetail) {
    return <ApplicationListItem key={detail.avUserId} item={detail} />
}
